import React from 'react';
import Modal from "../components/modals/Modal";

interface ReportIssueModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  issue: string;
  setIssue: (issue: string) => void;
  feedbackMessage: string | null;
  feedbackType: 'success' | 'error' | null;
  isLoading: boolean;
}

export const ReportIssueModal: React.FC<ReportIssueModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  issue,
  setIssue,
  feedbackMessage,
  feedbackType,
  isLoading,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6 max-w-lg mx-auto">
        <h2 className="text-2xl font-bold text-center mb-2"> Report an Issue</h2>
        <p className="text-gray-600 text-center mb-4">Let us know what went wrong.</p>

        <form
          className="flex flex-col gap-5"
          onSubmit={onSubmit}
        >
          <label className="text-gray-700 font-medium">Issue Details</label>
          <textarea
            placeholder="Describe the issue..."
            className="w-full min-h-[150px] resize-none px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50"
            required
            value={issue}
            onChange={(e) => setIssue(e.target.value)}
            disabled={isLoading}
          />

          {/* Success / Error message */}
          {feedbackMessage && (
            <div
              className={`w-full text-center font-medium p-3 rounded-md shadow-sm ${
                feedbackType === "success"
                  ? "text-green-700 bg-green-100 border border-green-400"
                  : "text-red-700 bg-red-100 border border-red-400"
              }`}
            >
              {feedbackMessage}
            </div>
          )}

          <div className="flex justify-end gap-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                isLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              disabled={isLoading}
            >
              {isLoading ? 'Submitting...' : 'Submit Report'}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
